<script lang="ts">
  import type { ComponentProps } from "svelte"
  import { tweened } from "svelte/motion"
  import Guide from "./Guide.svelte"
  import Rays from "./Rays.svelte"

  /** Percentage of filling of the left rays */
  export let left = 0
  /**Percentage of filling of the right rays */
  export let right = 0
  export let rotation = 0
  export let direction: ComponentProps<Guide>["direction"]
  export let complete = false

  const a = tweened(rotation, { duration: 100 })

  $: a.set(rotation)
</script>

<div class:complete>
  <Rays fill={left} />
  <Rays fill={right} />
  <Guide rotation={$a} {direction} />
</div>

<style lang="postcss">
  * {
    @apply relative flex h-full w-full text-[#B5FF6A];

    /* rays */
    & > :global(*:nth-child(1)),
    & > :global(*:nth-child(2)) {
      @apply !absolute top-1/2 -translate-y-1/2;
    }

    /* left rays */
    & > :global(*:nth-child(1)) {
      @apply left-1/2 -translate-x-full -scale-x-100;
    }
    /* right rays */
    & > :global(*:nth-child(2)) {
      @apply right-1/2 translate-x-full;
    }

    /* guide */
    & > :global(*:nth-child(3)) {
      @apply !absolute left-1/2 -translate-x-1/2;
    }
    /* guide */
    &.complete > :global(*:nth-child(3)) {
      @apply opacity-0 transition-opacity duration-300;
    }
  }
</style>
